<template>
    <div  class="cs-course-name-cell">
        <div>
          <i class="fa fa-folder fa-3 color-blue" aria-hidden="true" @click="onClick"></i>
            <span class="cs-course-name" @click="onClick">{{name}}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cs-course-name-cell{
    i{
        cursor: pointer;
        font-size: 2em;
    }
    .color-blue{
    color: #5DC0E4;
    }
    .cs-course-name {
        vertical-align:super;
        cursor: pointer;
        margin-left: 1em;
    }
}
</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            name: '',
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.name = this.data.CourseName;
            }
        },
        onClick() {
            let data = {
                action: "nav",
                data: this.data
            }
            this.$emit("customEvent",data);
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/coursewareNameCell.vue